import { render, staticRenderFns } from "./drugPremangePatientList.vue?vue&type=template&id=650e241a&scoped=true"
import script from "./drugPremangePatientList.vue?vue&type=script&lang=js"
export * from "./drugPremangePatientList.vue?vue&type=script&lang=js"
import style0 from "./drugPremangePatientList.vue?vue&type=style&index=0&id=650e241a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650e241a",
  null
  
)

export default component.exports